import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const UPDATE_CASE_MANULLY = "UPDATE_CASE_MANULLY";

export const service = async (caseToAdd) => {
  const options: object = {
    url: "/api/EaCaseApiController/UpdateCaseManually",
    method: "POST",
    body: JSON.stringify(caseToAdd),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(UPDATE_CASE_MANULLY, service, mock);
